/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-09-09 11:16:11
 * @LastEditors: Andy
 * @LastEditTime: 2023-11-21 16:19:23
 * @FilePath: /njyx-frontend-pc/packages/main/src/router/index.ts
 * @Description:路由
 *
 */

import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "登录",
      quick: false,
    },
  },
  {
    path: "/findpwd",
    name: "findpwd",
    component: () => import("@/views/FindPassword.vue"),
    meta: {
      title: "找回密码",
      quick: false,
    },
  },

  {
    path: "/",
    name: "main",
    component: () => import("../views/Main.vue"),
    redirect: { name: "home" },
    children: [
      //首页
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home.vue"),
      },
      /*************** #start 系统权限管理 *********************/
      {
        path: "/zzmenu",
        name: "zzmenu",
        component: () => import("@/views/ZzMenu.vue"),
        meta: {
          title: "菜单配置",
          quick: false,
        },
      },
      {
        path: "/zzrole",
        name: "zzrole",
        component: () => import("@/views/ZzRole.vue"),
        meta: {
          title: "角色配置",
          quick: false,
        },
      },
      /*************** #end 系统权限管理 *********************/
      /*************** #start 基础中心 *********************/
      // 权限管理
      {
        path: "/permission-manage/role/list",
        name: "permission-manage-role-list",
        component: () =>
          import("../views/base-center/permission-manage/role/List.vue"),
      },
      {
        path: "/permission-manage/role/add",
        name: "permission-manage-role-add",
        component: () =>
          import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/permission-manage/role/edit",
        name: "permission-manage-role-edit",
        component: () =>
          import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/permission-manage/user/list",
        name: "permission-manage-user-list",
        component: () =>
          import("../views/base-center/permission-manage/user/List.vue"),
      },
      {
        path: "/permission-manage/user/add",
        name: "permission-manage-user-add",
        component: () =>
          import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/permission-manage/user/edit",
        name: "permission-manage-user-edit",
        component: () =>
          import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/permission-manage/user/view",
        name: "permission-manage-user-view",
        component: () =>
          import("../views/base-center/permission-manage/user/View.vue"),
      },
      // 基础商品
      {
        path: "/base-goods/nation/list",
        name: "base-goods-nation-list",
        component: () =>
          import("../views/base-center/base-goods/nation/List.vue"),
      },
      {
        path: "/base-goods/nation/add",
        name: "base-goods-nation-add",
        component: () =>
          import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-goods/nation/edit",
        name: "base-goods-nation-edit",
        component: () =>
          import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-goods/brand/list",
        name: "base-goods-brand-list",
        component: () =>
          import("../views/base-center/base-goods/brand/List.vue"),
      },
      {
        path: "/base-goods/brand/add",
        name: "base-goods-brand-add",
        component: () =>
          import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-goods/brand/edit",
        name: "base-goods-brand-edit",
        component: () =>
          import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-goods/label/list",
        name: "base-goods-label-list",
        component: () =>
          import("../views/base-center/base-goods/label/List.vue"),
      },
      {
        path: "/base-goods/label/add",
        name: "base-goods-label-add",
        component: () =>
          import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-goods/label/edit",
        name: "base-goods-label-edit",
        component: () =>
          import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-goods/category/list",
        name: "base-goods-category-list",
        component: () =>
          import("../views/base-center/base-goods/category/List.vue"),
      },
      {
        path: "/base-goods/attribute/list",
        name: "base-goods-attribute-list",
        component: () =>
          import("../views/base-center/base-goods/attribute/List.vue"),
      },
      {
        path: "/base-goods/attribute/add",
        name: "base-goods-attribute-add",
        component: () =>
          import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-goods/attribute/edit",
        name: "base-goods-attribute-edit",
        component: () =>
          import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-goods/spu/list",
        name: "base-goods-spu-list",
        component: () => import("../views/base-center/base-goods/spu/List.vue"),
      },
      {
        path: "/base-goods/spu/add",
        name: "base-goods-spu-add",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-goods/spu/edit",
        name: "base-goods-spu-edit",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-goods/sku/list",
        name: "base-goods-sku-list",
        component: () => import("../views/base-center/base-goods/sku/List.vue"),
      },
      {
        path: "/base-goods/sku/add",
        name: "base-goods-sku-add",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-goods/sku/edit",
        name: "/base-goods/sku/edit",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-goods/sku/view",
        name: "base-goods-sku-view",
        component: () => import("../views/base-center/base-goods/sku/View.vue"),
      },
      {
        path: "/base-goods/batch/list",
        name: "base-goods-batch-list",
        component: () =>
          import("../views/base-center/base-goods/batch/List.vue"),
      },
      {
        path: "/base-goods/batch/view",
        name: "base-goods-batch-view",
        component: () =>
          import("../views/base-center/base-goods/batch/View.vue"),
      },
      {
        path: "/base-goods/evaluation/list",
        name: "base-goods-evaluation-list",
        component: () =>
          import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      {
        path: "/base-goods/evaluation/list",
        name: "base-goods-evaluation-list",
        component: () =>
          import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      // 库位运费
      {
        path: "/warhouse-freight/warhouse/list",
        name: "warhouse-freight-warhouse-list",
        component: () =>
          import("../views/base-center/warhouse-freight/warhouse/List.vue"),
      },
      {
        path: "/warhouse-freight/warhouse/add",
        name: "warhouse-freight-warhouse-add",
        component: () =>
          import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/warhouse-freight/warhouse/edit",
        name: "warhouse-freight-warhouse-edit",
        component: () =>
          import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/warhouse-freight/freight/list",
        name: "warhouse-freight-freight-list",
        component: () =>
          import("../views/base-center/warhouse-freight/freight/List.vue"),
      },
      {
        path: "/warhouse-freight/freight/add",
        name: "warhouse-freight-freight-add",
        component: () =>
          import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },
      {
        path: "/warhouse-freight/freight/edit",
        name: "warhouse-freight-freight-edit",
        component: () =>
          import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },

      //   用户管理
      {
        path: "/user-manage/chain-manage/list",
        name: "user-manage-chain-manage-list",
        component: () =>
          import("../views/base-center/user-manage/chain-manage/List.vue"),
      },
      {
        path: "/user-manage/chain-manage/add",
        name: "user-manage-chain-manage-add",
        component: () =>
          import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/user-manage/chain-manage/edit",
        name: "user-manage-chain-manage-edit",
        component: () =>
          import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/user-manage/chain-manage/view",
        name: "user-manage-chain-manage-view",
        component: () =>
          import("../views/base-center/user-manage/chain-manage/View.vue"),
      },
      //邀请码
      {
        path: "/user-manage/invitation-code/list",
        name: "user-manage-invitation-code-list",
        component: () =>
          import("../views/base-center/user-manage/invitation-code/List.vue"),
      },
      {
        path: "/user-manage/invitation-code/add",
        name: "user-manage-invitation-code-add",
        component: () =>
          import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/user-manage/invitation-code/edit",
        name: "user-manage-invitation-code-edit",
        component: () =>
          import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/user-manage/invitation-code/view",
        name: "user-manage-invitation-code-view",
        component: () =>
          import("../views/base-center/user-manage/invitation-code/View.vue"),
      },
      //门店管理
      {
        path: "/user-manage/shop-manage/list",
        name: "user-manage-shop-manage-list",
        component: () =>
          import("../views/base-center/user-manage/shop-manage/List.vue"),
      },
      {
        path: "/user-manage/shop-manage/add",
        name: "user-manage-shop-manage-add",
        component: () =>
          import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/user-manage/shop-manage/edit",
        name: "user-manage-shop-manage-edit",
        component: () =>
          import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/user-manage/shop-manage/view",
        name: "user-manage-shop-manage-view",
        component: () =>
          import("../views/base-center/user-manage/shop-manage/View.vue"),
      },
      //员工管理
      {
        path: "/user-manage/staff-manage/list",
        name: "user-manage-staff-manage-list",
        component: () =>
          import("../views/base-center/user-manage/staff-manage/List.vue"),
      },
      {
        path: "/user-manage/staff-manage/add",
        name: "user-manage-staff-manage-add",
        component: () =>
          import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/user-manage/staff-manage/edit",
        name: "user-manage-staff-manage-edit",
        component: () =>
          import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/user-manage/staff-manage/view",
        name: "user-manage-staff-manage-view",
        component: () =>
          import("../views/base-center/user-manage/staff-manage/View.vue"),
      },
      //会员列表
      {
        path: "/user-manage/member-manage/list",
        name: "user-manage-member-manage-list",
        component: () =>
          import("../views/base-center/user-manage/member-manage/List.vue"),
      },
      {
        path: "/user-manage/member-manage/view",
        name: "user-manage-member-manage-view",
        component: () =>
          import("../views/base-center/user-manage/member-manage/View.vue"),
      },

      //销售管理
      {
        path: "/user-manage/sales-manage/list",
        name: "user-manage-sales-manage-list",
        component: () =>
          import("../views/base-center/user-manage/sales-manage/List.vue"),
      },
      {
        path: "/user-manage/sales-manage/add",
        name: "user-manage-sales-manage-add",
        component: () =>
          import("../views/base-center/user-manage/sales-manage/Add.vue"),
      },
      {
        path: "/user-manage/sales-manage/edit",
        name: "user-manage-sales-manage-edit",
        component: () =>
          import("../views/base-center/user-manage/sales-manage/Add.vue"),
      },
      {
        path: "/user-manage/sales-manage/view",
        name: "user-manage-sales-manage-view",
        component: () =>
          import("../views/base-center/user-manage/sales-manage/View.vue"),
      },

      //提报管理
      {
        path: "/user-manage/reporting-manage/list",
        name: "user-manage-reporting-manage-list",
        component: () =>
          import("../views/base-center/user-manage/reporting-manage/List.vue"),
      },
      {
        path: "/user-manage/reporting-manage/view",
        name: "user-manage-reporting-manage-view",
        component: () =>
          import("../views/base-center/user-manage/reporting-manage/View.vue"),
      },

      //   批次分发规则
      {
        path: "/system-configuration/batch-distribute/list",
        name: "system-configuration-batch-distribute-list",
        component: () =>
          import(
            "../views/base-center/system-configuration/batch-distribute/List.vue"
          ),
      },
      //   系统配置
      //下单规则
      {
        path: "/system-configuration/order-rule/list",
        name: "system-configuration-order-rule-list",
        component: () =>
          import("../views/base-center/system-configuration/order-rule/List.vue"),
      },
      {
        path: "/system-configuration/order-rule/add",
        name: "system-configuration-order-rule-add",
        component: () =>
          import("../views/base-center/system-configuration/order-rule/Add.vue"),
      },
      {
        path: "/system-configuration/order-rule/edit",
        name: "system-configuration-order-rule-edit",
        component: () =>
          import("../views/base-center/system-configuration/order-rule/Add.vue"),
      },
      {
        path: "/system-configuration/order-rule/view",
        name: "system-configuration-order-rule-view",
        component: () =>
          import("../views/base-center/system-configuration/order-rule/View.vue"),
      },

      {
        path: "/system-configuration/download/list",
        name: "system-configuration-download-list",
        component: () =>
          import("../views/base-center/system-configuration/download/List.vue"),
      },
      {
        path: "/system-configuration/commission-rule/list",
        name: "system-configuration-commission-rule-list",
        component: () =>
          import(
            "../views/base-center/system-configuration/commission-rule/List.vue"
          ),
      },
      {
        path: "/system-configuration/commission-rule/add",
        name: "system-configuration-commission-rule-add",
        component: () =>
          import(
            "../views/base-center/system-configuration/commission-rule/Add.vue"
          ),
      },
      {
        path: "/system-configuration/commission-rule/edit",
        name: "system-configuration-commission-rule-edit",
        component: () =>
          import(
            "../views/base-center/system-configuration/commission-rule/Add.vue"
          ),
      },
      {
        path: "/system-configuration/commission-rule/view",
        name: "system-configuration-commission-rule-view",
        component: () =>
          import(
            "../views/base-center/system-configuration/commission-rule/View.vue"
          ),
      },
      {
        path: "/system-configuration/system-rule/list",
        name: "system-configuration-system-rule-list",
        component: () =>
          import(
            "../views/base-center/system-configuration/system-rule/List.vue"
          ),
      },
      //平台协议
      {
        path: "/system-configuration/platform-agreement/list",
        name: "system-configuration-platform-agreement-list",
        component: () =>
          import(
            "../views/base-center/system-configuration/platform-agreement/List.vue"
          ),
      },
      //app版本管理
      {
        path: "/system-configuration/APP-version/list",
        name: "system-configuration-APP-version-list",
        component: () =>
          import(
            "../views/base-center/system-configuration/APP-version/List.vue"
          ),
      },
      {
        path: "/system-configuration/APP-version/add",
        name: "system-configuration-APP-version-add",
        component: () =>
          import(
            "../views/base-center/system-configuration/APP-version/Add.vue"
          ),
      },
      /*************** #end 基础中心 *********************/
      /*************** #start 零售中心 *********************/
      //   商品管理
      {
        path: "/goods-manage/retail-goods/list",
        name: "goods-manage-retail-goods-list",
        component: () =>
          import("../views/retail-center/goods-manage/retail-goods/List.vue"),
      },
      {
        path: "/goods-manage/retail-goods/add",
        name: "goods-manage-retail-goods-add",
        component: () =>
          import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/goods-manage/retail-goods/edit",
        name: "goods-manage-retail-goods-edit",
        component: () =>
          import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/goods-manage/retail-goods/view",
        name: "goods-manage-retail-goods-view",
        component: () =>
          import("../views/retail-center/goods-manage/retail-goods/View.vue"),
      },
      //   备案信息
      {
        path: "/goods-manage/record-info/list",
        name: "goods-manage-record-info-list",
        component: () =>
          import("../views/retail-center/goods-manage/record-info/List.vue"),
      },
      {
        path: "/goods-manage/record-info/add",
        name: "goods-manage-record-info-add",
        component: () =>
          import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/goods-manage/record-info/edit",
        name: "goods-manage-record-info-edit",
        component: () =>
          import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/goods-manage/record-info/view",
        name: "goods-manage-record-info-view",
        component: () =>
          import("../views/retail-center/goods-manage/record-info/View.vue"),
      },
      //   库存配额
      {
        path: "/stock-quota/stock/list",
        name: "stock-quota-stock-list",
        component: () =>
          import("../views/retail-center/stock-quota/stock/List.vue"),
      },
      {
        path: "/stock-quota/stock/add",
        name: "stock-quota-stock-add",
        component: () =>
          import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/stock-quota/stock/edit",
        name: "stock-quota-stock-edit",
        component: () =>
          import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/stock-quota/stock/view",
        name: "stock-quota-stock-view",
        component: () =>
          import("../views/retail-center/stock-quota/stock/View.vue"),
      },
      {
        path: "/stock-quota/quota/list",
        name: "stock-quota-quota-list",
        component: () =>
          import("../views/retail-center/stock-quota/quota/List.vue"),
      },
      {
        path: "/stock-quota/quota/add",
        name: "stock-quota-quota-add",
        component: () =>
          import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/stock-quota/quota/edit",
        name: "stock-quota-quota-edit",
        component: () =>
          import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/stock-quota/quota/view",
        name: "stock-quota-quota-view",
        component: () =>
          import("../views/retail-center/stock-quota/quota/View.vue"),
      },

      //   交易管理
      //平台订单
      {
        path: "/transaction-management/order/list",
        name: "transaction-management-order-list",
        component: () =>
          import(
            "../views/retail-center/transaction-management/order/List.vue"
          ),
      },
      {
        path: "/transaction-management/order/add",
        name: "transaction-management-order-add",
        component: () =>
          import("../views/retail-center/transaction-management/order/Add.vue"),
      },
      {
        path: "/transaction-management/order/edit",
        name: "transaction-management-order-edit",
        component: () =>
          import("../views/retail-center/transaction-management/order/Add.vue"),
      },
      {
        path: "/transaction-management/order/view",
        name: "transaction-management-order-view",
        component: () =>
          import(
            "../views/retail-center/transaction-management/order/View.vue"
          ),
      },
      {
        path: "/transaction-management/order/addChargeback",
        name: "transaction-management-order-addChargeback",
        component: () =>
          import("../views/retail-center/transaction-management/order/AddChargeback.vue"),
      },
      {
        path: "/transaction-management/order/belong",
        name: "transaction-management-order-change-order-belong",
        component: () =>
          import("../views/retail-center/transaction-management/order/ChangeOrderBelong.vue")
      },
      //平台退单
      {
        path: "/transaction-management/Chargebacks/list",
        name: "transaction-management-Chargebacks-list",
        component: () =>
          import(
            "../views/retail-center/transaction-management/Chargebacks/List.vue"
          ),
      },

      {
        path: "/transaction-management/Chargebacks/view",
        name: "transaction-management-Chargebacks-view",
        component: () =>
          import(
            "../views/retail-center/transaction-management/Chargebacks/View.vue"
          ),
      },

      /*************** #end 零售中心 *********************/
      /*************** #start 运营中心 *********************/
      //   c端优惠券
      {
        path: "/customer-coupon/coupon/list",
        name: "customer-coupon-coupon-list",
        component: () =>
          import("../views/operate-center/customer-coupon/coupon/List.vue"),
      },
      {
        path: "/customer-coupon/coupon/add",
        name: "customer-coupon-coupon-add",
        component: () =>
          import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/customer-coupon/coupon/edit",
        name: "customer-coupon-coupon-edit",
        component: () =>
          import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/customer-coupon/coupon/view",
        name: "customer-coupon-coupon-view",
        component: () =>
          import("../views/operate-center/customer-coupon/coupon/View.vue"),
      },
      {
        path: "/customer-coupon/coupon-grant/list",
        name: "customer-coupon-coupon-grant-list",
        component: () =>
          import(
            "../views/operate-center/customer-coupon/coupon-grant/List.vue"
          ),
      },
      {
        path: "/customer-coupon/coupon-grant/view",
        name: "customer-coupon-coupon-grant-view",
        component: () =>
          import(
            "../views/operate-center/customer-coupon/coupon-grant/View.vue"
          ),
      },
      //   c端促销
      {
        path: "/customer-promotion/combine-activity/list",
        name: "customer-promotion-combine-activity-list",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/combine-activity/List.vue"
          ),
      },
      {
        path: "/customer-promotion/combine-activity/add",
        name: "customer-promotion-combine-activity-add",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/combine-activity/Add.vue"
          ),
      },
      {
        path: "/customer-promotion/combine-activity/edit",
        name: "customer-promotion-combine-activity-edit",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/combine-activity/Add.vue"
          ),
      },
      {
        path: "/customer-promotion/combine-activity/view",
        name: "customer-promotion-combine-activity-view",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/combine-activity/View.vue"
          ),
      },
      {
        path: "/customer-promotion/special-price/list",
        name: "customer-promotion-special-price-list",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/special-price/List.vue"
          ),
      },
      {
        path: "/customer-promotion/special-price/add",
        name: "customer-promotion-special-price-add",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/special-price/Add.vue"
          ),
      },
      {
        path: "/customer-promotion/special-price/edit",
        name: "customer-promotion-special-price-edit",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/special-price/Add.vue"
          ),
      },
      {
        path: "/customer-promotion/special-price/view",
        name: "customer-promotion-special-price-view",
        component: () =>
          import(
            "../views/operate-center/customer-promotion/special-price/View.vue"
          ),
      },
      //   消息广告
      {
        path: "/message-ad/app-ad/list",
        name: "message-ad-app-ad-list",
        component: () =>
          import("../views/operate-center/message-ad/app-ad/List.vue"),
      },
      {
        path: "/message-ad/app-ad/add",
        name: "message-ad-app-ad-add",
        component: () =>
          import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/message-ad/app-ad/edit",
        name: "message-ad-app-ad-edit",
        component: () =>
          import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/message-ad/mp-ad/list",
        name: "message-ad-mp-ad-list",
        component: () =>
          import("../views/operate-center/message-ad/mp-ad/List.vue"),
      },
      {
        path: "/message-ad/mp-ad/add",
        name: "message-ad-mp-ad-add",
        component: () =>
          import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },
      {
        path: "/message-ad/mp-ad/edit",
        name: "message-ad-mp-ad-edit",
        component: () =>
          import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },

      {
        path: "/message-ad/dsr-ad/list",
        name: "message-ad-dsr-ad-list",
        component: () =>
          import("../views/operate-center/message-ad/dsr-ad/List.vue"),
      },
      {
        path: "/message-ad/dsr-ad/add",
        name: "message-ad-dsr-ad-add",
        component: () =>
          import("../views/operate-center/message-ad/dsr-ad/Add.vue"),
      },
      {
        path: "/message-ad/dsr-ad/edit",
        name: "message-ad-dsr-ad-edit",
        component: () =>
          import("../views/operate-center/message-ad/dsr-ad/Add.vue"),
      },

      //消息通知
      {
        path: "/message-ad/message-notification/list",
        name: "message-ad-message-notification-list",
        component: () =>
          import(
            "../views/operate-center/message-ad/message-notification/List.vue"
          ),
      },
      {
        path: "/message-ad/message-notification/add",
        name: "message-ad-message-notification-add",
        component: () =>
          import(
            "../views/operate-center/message-ad/message-notification/Add.vue"
          ),
      },
      {
        path: "/message-ad/message-notification/edit",
        name: "message-ad-message-notification-edit",
        component: () =>
          import(
            "../views/operate-center/message-ad/message-notification/Add.vue"
          ),
      },
      // 内容管理
      {
        path: "/content-manage/sell-material/list",
        name: "content-manage-sell-material-list",
        component: () =>
          import(
            "../views/operate-center/content-manage/sell-material/List.vue"
          ),
      },
      {
        path: "/content-manage/sell-material/add",
        name: "content-manage-sell-material-add",
        component: () =>
          import(
            "../views/operate-center/content-manage/sell-material/Add.vue"
          ),
      },
      {
        path: "/content-manage/sell-material/edit",
        name: "content-manage-sell-material-edit",
        component: () =>
          import(
            "../views/operate-center/content-manage/sell-material/Add.vue"
          ),
      },
      {
        path: "/content-manage/article/list",
        name: "content-manage-article-list",
        component: () =>
          import("../views/operate-center/content-manage/article/List.vue"),
      },
      {
        path: "/content-manage/article/add",
        name: "content-manage-article-add",
        component: () =>
          import("../views/operate-center/content-manage/article/Add.vue"),
      },
      {
        path: "/content-manage/article/edit",
        name: "content-manage-article-edit",
        component: () =>
          import("../views/operate-center/content-manage/article/Add.vue"),
      },

      //广告素材
      {
        path: "/content-manage/ad-material/list",
        name: "content-manage-ad-material-list",
        component: () =>
          import("../views/operate-center/content-manage/ad-material/List.vue"),
      },
      {
        path: "/content-manage/ad-material/add",
        name: "content-manage-ad-material-add",
        component: () =>
          import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },
      {
        path: "/content-manage/ad-material/edit",
        name: "content-manage-ad-material-edit",
        component: () =>
          import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },

      //连锁收益
      {
        path: "/financial-manage/chain-earnings/list",
        name: "financial-manage-chain-earnings-list",
        component: () =>
          import(
            "../views/operate-center/financial-manage/chain-earnings/List.vue"
          ),
      },
      {
        path: "/financial-manage/chain-earnings/Add",
        name: "financial-manage-chain-earnings-Add",
        component: () =>
          import(
            "../views/operate-center/financial-manage/chain-earnings/Add.vue"
          ),
      },
      //提现明细
      {
        path: "/financial-manage/withdrawal-details/list",
        name: "financial-manage-withdrawal-details-list",
        component: () =>
          import(
            "../views/operate-center/financial-manage/withdrawal-details/List.vue"
          ),
      },

      {
        path: "/financial-manage/withdrawal-details/view",
        name: "financial-manage-withdrawal-details-view",
        component: () =>
          import(
            "../views/operate-center/financial-manage/withdrawal-details/View.vue"
          ),
      },
      //对账单
      {
        path: "/financial-manage/account-statement/list",
        name: "financial-manage-account-statement-list",
        component: () =>
          import(
            "../views/operate-center/financial-manage/account-statement/List.vue"
          ),
      },
      {
        path: "/financial-manage/account-statement/view",
        name: "financial-manage-account-statement-view",
        component: () =>
          import(
            "../views/operate-center/financial-manage/account-statement/View.vue"
          ),
      },
      {
        path: "/financial-manage/account-statement/details",
        name: "financial-manage-account-statement-details",
        component: () =>
          import(
            "../views/operate-center/financial-manage/account-statement/Details.vue"
          ),
      },
      //报表数据
      //销售报表
      {
        path: '/reportData/salesSignage/view',
        name: 'reportData-salesSignage-view',
        component: () => import('../views/operate-center/report-data/sales-signage/View.vue'),
      },
      //广告确认报表
      {
        path: "/advertising-report/confirm/list",
        name: "advertising-report/confirm-list",
        component: () =>
          import("../views/operate-center/advertising-report/confirm/List.vue"),
      },
      //协议统计列表
      {
        path: "/protocol-statistics/list",
        name: "protocol-statistics-list",
        component: () => import("../views/operate-center/protocol-statistics/List.vue"),
      },
      //直播列表
      {
        path: "/live-broadcast/live-manage/list",
        name: "live-broadcast-live-manage-list",
        component: () =>
          import("../views/operate-center/live-broadcast/live-manage/List.vue"),
      },
      {
        path: "/live-broadcast/live-manage/view",
        name: "live-broadcast-live-manage-view",
        component: () =>
          import("../views/operate-center/live-broadcast/live-manage/View.vue"),
      },
      {
        path: "/live-broadcast/live-manage/add",
        name: "live-broadcast-live-manage-add",
        component: () =>
          import("../views/operate-center/live-broadcast/live-manage/Add.vue"),
      },
      {
        path: "/live-broadcast/live-manage/edit",
        name: "live-broadcast-live-manage-edit",
        component: () =>
          import(
            "../views/operate-center/live-broadcast/live-manage/Add.vue"
          ),
      },
      //主播列表
      {
        path: "/live-broadcast/anchor/list",
        name: "live-broadcast-anchor-list",
        component: () =>
          import("../views/operate-center/live-broadcast/anchor/List.vue"),
      },
      /*************** #end 运营中心 *********************/
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
